import React from 'react';

export const UnorderedList: React.FC = (props) => (
  <ul {...props} className="font-body leading-relaxed text-justify pl-6 list-inside list-disc" />
);
